/* eslint camelcase: 0 */

import { PermissionsGroup as Data } from '@/typings/api/PermissionsGroup'
import { Model, createMessages } from '@/helpers/Model'


export class PermissionsGroupModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить группу',
    edit: 'Редактировать группу',
    view: (data: PermissionsGroupModel) => 'Группа «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Группы',
  });

  public static readonly modal_delete = createMessages({
    delete: (data: PermissionsGroupModel) => 'Удаление группы «{name}»'
      .replace('{name}', data.name || '...'),
    delete_all: 'Удаление выбранных групп',
    delete_all_partly: 'Удаление части выбранных групп',
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
    delete_all_deny: 'Выбранные группы нельзя удалить',
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });
}
